import axios from 'axios'
import { toast } from 'react-toastify'
import { getErrorText } from '../error'
import { isReallyOnline } from '../offline/isReallyOnline'
import { getHasShownToast, setHasShownToast } from '../offline/offlineToastState'

export const setAxiosResInterceptor = (store) => {
  axios.interceptors.response.use(
    async (res) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // console.log(res)
      const { status } = res.data
      if (status === 0) {
        const {
          message = 'Server Error',
          data: { message: dataMessage = '', status: dataStatus = '' } = {},
          error,
          error: { message: errorMessage = '' } = {},
        } = res.data
        let alertErrMessage = message
        if (error) {
          if (errorMessage) alertErrMessage += `: ${errorMessage}`
        } else {
          if (dataStatus || dataMessage) alertErrMessage += `: ${dataStatus} ${dataMessage}`
        }
        toast.error(alertErrMessage)
        return Promise.reject(alertErrMessage)
      }
      return res
    },
    async (err) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // console.log(err)
      // const statusCode = getErrorStatusCode(err)
      let errMessage = getErrorText(err)
      // if (statusCode === 401) store.dispatch(logout())
      if (!(await isReallyOnline())) {
        if (!getHasShownToast()) {
          // Show toast only once when offline per page load
          setHasShownToast(true)
          errMessage = 'Ви працюєте в офлайн-режимі'
          toast.error(errMessage)
        }
        return Promise.reject(errMessage)
      }
      toast.error(errMessage)
      return Promise.reject(errMessage)
    },
  )
}
